import { useMutation } from '@tanstack/react-query';
import { instance } from '@configs';
import { toast } from 'react-toastify';

import { getContentInHtml } from '@utils';

import { IData, ITestParams } from './types';

export const useSendTestQuery = () => {
  return useMutation({
    mutationFn: async (params: ITestParams) => {
      // const formData: FormData = new FormData();
      // formData.append('key', params.key);
      // formData.append('callbackUrl', params.callbackUrl);
      // formData.append('returnUrl', params.returnUrl);
      // formData.append('orderId', params.orderId);
      // formData.append('info', params.info);
      // formData.append('email', params.email);
      // formData.append('phone', params.phone);
      // formData.append('infoHash', params.infoHash);
      // formData.append('amount', params.amount);
      // formData.append('gate', params.gate);
      // formData.append('token', params.token);
      // formData.append('requestId', params.requestId);
      // formData.append('clientId', params.clientId);

      const jsonData = {
        data: {
          key: params.key,
          callbackUrl: params.callbackUrl,
          returnUrl: params.returnUrl,
          orderId: params.orderId,
          info: params.info,
          email: params.email,
          phone: params.phone,
          infoHash: params.infoHash,
          amount: params.amount,
          gate: params.gate,
          token: params.token,
          requestId: params.requestId,
          clientId: params.clientId,
        },
      };

      const jsonDataForOrdinary = {
        key: params.key,
        callback_url: params.callbackUrl,
        return_url: params.returnUrl,
        order_id: params.orderId,
        info: params.info,
        email: params.email,
        phone: params.phone,
        infoHash: params.infoHash,
        amount: params.amount,
        gate: params.gate,
        token: params.token,
        request_id: params.requestId,
        client_id: params.clientId,
      };

      // const { data } = await instance.post('', formData);
      const jsonDataForTokenized = params.gate.startsWith('tokenization')
        ? jsonData
        : jsonDataForOrdinary;

      const { data } = await instance.post('/v2/', jsonDataForTokenized, {
        headers: { gate: `${params.gate}` },
      });

      // return getContentInHtml(data);
      return {
        responseData: data,
        parsed: getContentInHtml(data),
      };
    },
    onSuccess: ({ parsed, responseData }: IData) => {
      window.location.href = responseData.url;

      const [stk] = parsed;
      if (stk.length > 10) {
        toast.error(stk);
        // const token: string = stk.split(':')[1];
        // setToken(token);
        // window.location.href = '/';
      }
    },
  });
};
